import { z } from 'zod';

export const projectTourDtoSchema = z.object({
  id: z.number(),
  organisationId: z.number(),
  name: z.string(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  image: z.string().nullable(),
  models: z.object({
    ess: z.string(),
    env: z.string(),
  }),
});

export const getProjectsTourDtoSchema = z.object({
  data: z.array(projectTourDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export const getProjectTourDtoSchema = projectTourDtoSchema;

export type ProjectTourDto = z.infer<typeof projectTourDtoSchema>;
